export default {
  ROOM_LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? [...(value.sort((a, b) => a.name.localeCompare(b.name)))] : []
  },
  ROOM_LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, Object.assign(state.list[index], value))
    } else {
      state.list.push(value) // reason: see fetchModel.js
    }
  },
  ROOM_LIST_ITEM_REMOVE (state, value) {
    const id = typeof value === 'string' ? value : typeof value === 'object' && value.id ? value.id : ''
    const index = state.list.findIndex((i) => i.id === id)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  ROOM_CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'name', 'building']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      if (!value.socketUpdate) {
        state.current.alarms = value.alarms
      }
      // state.current.tags = value.tags
      // state.current.points = value.points
      // state.current.building = value.building
      // state.current.healthCheckKinds = value.healthCheckKinds
    } else {
      state.current = {
        id: '',
        name: '',
        building: '',
        tags: [],
        points: [],
        healthChecks: [],
        healthCheckKinds: [],
        alarms: []
      }
      state.update = {
        id: '',
        name: ''
      }
    }
  },
  ROOM_UPDATE_NAME (state, value) {
    state.update.name = value
  }
}
